const initialState = {
    requestingDownloadManifest: false,
    successDownloadManifest: false,
    errorDownloadManifest: false,
}

export default function WMSManifestReducer(state = initialState, action) {
    switch (action.type) {
        case "DOWNLOAD_MANIFEST_REQUESTING":
            return {
                ...state,
                requestingDownloadManifest: true,
                successDownloadManifest: false,
                errorDownloadManifest: false,
            };
        case "DOWNLOAD_MANIFEST_SUCCESS":
            return {
                ...state,
                requestingDownloadManifest: false,
                successDownloadManifest: true,
                errorDownloadManifest: false,
            };
        case "DOWNLOAD_MANIFEST_ERROR":
            return {
                ...state,
                requestingDownloadManifest: false,
                successDownloadManifest: false,
                errorDownloadManifest: true,
            };
        default:
            return state;
    }
}